/**
 * @param iframe
 */
const reivewsStyles = (iframe) => {
  const titleElement = document.querySelector('.trustpilot-reviews-section .section__heading');
  const accordionReviews = document.getElementById('accordion_reviews');
  const computedStyles = window.getComputedStyle(iframe);
  const displayStyle = computedStyles.getPropertyValue('display');
  if (displayStyle === 'none') {
    titleElement.classList.add('hidden');
    if (accordionReviews !== null) {
      accordionReviews.classList.add('hidden');
    }
  } else {
    titleElement.classList.remove('hidden');
    if (accordionReviews !== null) {
      accordionReviews.classList.remove('hidden');
    }
  }
};

/**
 * Observe to section is on screen
 */
const containerObserver = (wrapperId) => {
  const wrapper = document.getElementById(wrapperId);
  const observer = new MutationObserver((mutationsList) => {
    mutationsList.forEach((mutation) => {
      if (mutation.type === 'childList') {
        const iframe = wrapper.getElementsByTagName('iframe');
        if (iframe.length > 0) {
          reivewsStyles(iframe[0]);
        }
      }
    });
  });
  const config = { childList: true, subtree: true };
  observer.observe(document.body, config);
};

document.addEventListener('DOMContentLoaded', () => {
  containerObserver('reviews');
});
